import './smtpFields.less';

import React from 'react';
import { observer } from 'mobx-react';
import b_ from 'b_';
import { CloseCircleOutlined } from '@ant-design/icons';
import { i18n } from 'core/localization';
import { Section } from 'controls/react/layout/section';
import { FormEntryNew } from 'controls/react/form/formEntryNew';
import { AntInput } from 'controls/react/ant/antInput';
import { AntInputNumber, NumberKeysPattern } from 'controls/react/ant/antInputNumber';
import { AntRadioGroup } from 'controls/react/ant/antRadio';
import { SmtpFieldsProps, SmtpSecurityProtocol } from 'areas/administration/authentication/smtp/types';

const b = b_.with('smtp-fields');

const SECRET_PLACEHOLDER = '••••••••';

const getProtocols = () => [
	{ id: SmtpSecurityProtocol.None, name: i18n('None') },
	{ id: SmtpSecurityProtocol.StartTls, name: i18n('StartTLS') },
	{ id: SmtpSecurityProtocol.Tls, name: i18n('TLS') },
];

export const SmtpFields = observer(({ store }: SmtpFieldsProps) => {
	const disabled = store.readOnly;

	return (
		<div className={b()}>
			<Section appearance={'frame'} title={i18n('Connection')} childrenPadding={true}>
				<FormEntryNew
					label={i18n('Protocol')}
					model={store.model}
					modelField={'securityProtocol'}
					onChange={(value: SmtpSecurityProtocol) => store.changeSecurityProtocol(value)}
					disabled={disabled}
				>
					<AntRadioGroup dataList={getProtocols()} buttonStyle={'solid'} />
				</FormEntryNew>
				<FormEntryNew
					label={i18n('Host')}
					placeholder={'smtp.example.com'}
					hasPlaceholder={true}
					model={store.model}
					validator={store.validator}
					modelField={'host'}
					disabled={disabled}
				>
					<AntInput />
				</FormEntryNew>
				<div>
					<FormEntryNew
						label={i18n('Port')}
						model={store.model}
						validator={store.validator}
						modelField={'port'}
						disabled={disabled}
					>
						<AntInputNumber pattern={NumberKeysPattern.PositiveInteger} min={1} max={65535} />
					</FormEntryNew>
					<div className={b('hint')}>{i18n('Port is populated based on the selected protocol')}</div>
				</div>
			</Section>
			<Section appearance={'frame'} title={i18n('Credentials')} childrenPadding={true}>
				<FormEntryNew
					label={i18n('Username')}
					placeholder={i18n('Username')}
					hasPlaceholder={true}
					model={store.model}
					validator={store.validator}
					modelField={'username'}
					disabled={disabled}
				>
					<AntInput autoComplete={'new-password'} />
				</FormEntryNew>
				<FormEntryNew
					label={i18n('Password')}
					placeholder={store.model.hasPassword ? SECRET_PLACEHOLDER : i18n('Password')}
					hasPlaceholder={true}
					model={store.model}
					validator={store.validator}
					modelField={'password'}
					disabled={disabled}
					headerAdditionalContent={
						store.model.hasPassword && !disabled ? (
							<CloseCircleOutlined
								className={b('clear-password')}
								title={i18n('Clear password')}
								onClick={() => store.clearStoredPassword()}
							/>
						) : undefined
					}
				>
					<AntInput type={'password'} autoComplete={'new-password'} />
				</FormEntryNew>
			</Section>
		</div>
	);
});
